import { Map } from 'immutable';

import * as t from '../actions/dailyQuizActionTypes';

const initialState = Map({
  timer: 1200, // 1200 secs are 20 mins so is the time for the test
  timerDisplay: '',
  timerStarted: false,

  startedDate: '',
  endDate: '',

  questionsAnswered: 0,
  questionsRemaining: 20,
  correctAnswers: 0,
  questions: [],

  pointsByQuestion: 0,
  pointsByAccuracy: 0,
  pointsByTime: 0,

  quizAvailable: true,
  results: {},

  checkDailyQuizStatusWaiting: false,
  nextQuizIn: null,
  dailyQuizRunning: null,
  loadDailyQuizWaiting: false,
  quiz: null,
  submitDailyQuizWaiting: false,
  submitDailyQuizSuccess: false,
  progress: 0,
  dailyTimeOut: false,

  // Qual daily quiz
  isQualDailyQuizLoading: false,
  isLoadingSubmitQualDailyQuiz: false,

  isQualDailyQuizRunning: null,
  nextQualDailyQuizIn: null,
  qualDailyQuizProgress: 0,

  qualDailyQuiz: null,

  qualDailyQuizDailyTimeout: false,

  isSubmitQualDailyQuizSuccessful: false,
});

const reducer = function dailyQuizReducer(state = initialState, action) {
  switch (action.type) {
    case t.START_TIMER:
      const endDate = new Date();

      endDate.setMinutes(endDate.getMinutes() + 20);
      return state
        .set('startedDate', new Date())
        .set('endDate', endDate)
        .set('timerStarted', true);

    case t.STOP_TIMER:
      return state.set('timer', action.value);

    case t.SET_DAILY_TIMEOUT:
      return state.set('dailyTimeOut', action.value);

    case t.SET_QUAL_DAILY_QUIZ_DAILY_TIMEOUT:
      return state.set('qualDailyQuizDailyTimeout', action.value);

    case t.SET_POINTS_CORRECT_ANSWER:
      return state.set('pointsByQuestion', state.get('pointsByQuestion') + 1);

    case t.SET_POINTS_ACCURACY:
      return state.set('pointsByAccuracy', state.get('pointsByAccuracy') + 1);

    case t.SET_POINTS_TIME:
      return state.set('pointsByTime', state.get('pointsByTime') + 1);

    case t.SET_CORRECT_ANSWER_COUNTER_DAILY:
      return state.set('correctAnswers', state.get('correctAnswers') + 1);

    case t.SET_ANSWERED_QUESTIONS:
      return state.set('questionsAnswered', state.get('questionsAnswered') + 1);

    case t.SET_REMAINING_QUESTIONS:
      return state.set(
        'questionsRemaining',
        state.get('questionsRemaining') - 1,
      );

    case t.SET_DAILY_QUIZ_QUESTIONS:
      return state.set('questions', action.questions);

    case t.UPDATE_TIMER:
      const sec = state.get('timer') - 1;
      const minutes = Math.floor(sec / 60);
      const seconds = sec - minutes * 60;
      return state
        .set('timerDisplay', `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`)
        .set('timer', sec);

    case t.SET_RESULTS_DAILY_QUIZ:
      return state.set('results', action.results);

    case t.SET_INITIAL_TIME:
      return state.set('timer', action.time);

    case t.SET_CHECK_DAILY_QUIZ_STATUS_WAITING:
      return state.set('checkDailyQuizStatusWaiting', action.value);

    case t.SET_NEXT_QUIZ_IN:
      return state.set('nextQuizIn', action.value);

    case t.SET_DAILY_QUIZ_RUNNING:
      return state.set('dailyQuizRunning', action.value);

    case t.SET_LOAD_DAILY_QUIZ_WAITING:
      return state.set('loadDailyQuizWaiting', action.value);

    case t.SET_DAILY_QUIZ:
      return state.set('quiz', action.quiz);

    case t.SET_DAILY_QUIZ_RETAKE:
      return state.set('quizRetake', action.quiz);

    case t.SET_QUAL_DAILY_QUIZ:
      return state.set('qualDailyQuiz', action.quiz);

    case t.SET_QUAL_DAILY_QUIZ_RETAKE:
      return state.set('qualDailyQuizRetake', action.quiz);

    case t.SET_SUBMIT_DAILY_QUIZ_WAITING:
      return state.set('submitDailyQuizWaiting', action.value);

    case t.SET_IS_LOADING_SUBMIT_QUAL_DAILY_QUIZ:
      return state.set('isLoadingSubmitQualDailyQuiz', action.value);

    case t.SET_SUBMIT_DAILY_QUIZ_SUCCESS:
      return state.set('submitDailyQuizSuccess', action.value);

    case t.SET_IS_SUBMIT_QUAL_DAILY_QUIZ_SUCCESSFUL:
      return state.set('isSubmitQualDailyQuizSuccessful', action.value);

    case t.SET_PROGRESS:
      return state.set('progress', action.progress);

    case t.SET_IS_LOADING_QUAL_DAILY_QUIZ_STATUS:
      return state.set('isQualDailyQuizLoading', action.value);

    case t.SET_IS_QUAL_DAILY_QUIZ_RUNNING:
      return state.set('isQualDailyQuizRunning', action.value);

    case t.SET_NEXT_QUAL_DAILY_QUIZ_IN:
      return state.set('nextQualDailyQuizIn', action.value);

    case t.SET_QUAL_DAILY_QUIZ_PROGRESS:
      return state.set('qualDailyQuizProgress', action.value);

    default:
      return state;
  }
};

export default reducer;
